import { c as _c } from "react/compiler-runtime";
import { GetStaticProps } from 'next';
import { Roots } from 'next-roots/context';
import CenikRoot, * as __root from 'roots/cenik';
function CenikPage(pageProps) {
  const $ = _c(2);
  let t0;
  if ($[0] !== pageProps) {
    t0 = <CenikRoot {...pageProps} />;
    $[0] = pageProps;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
CenikPage.getRoots = (): Partial<Roots> => ({
  currentLocale: 'cs',
  currentRoot: 'cenik',
  currentRule: {
    "key": "cs:cenik",
    "href": "/cenik"
  },
  currentMeta: {
    "key": "cs:cenik",
    "data": {}
  },
  rules: [{
    "key": "cs:home",
    "href": "/"
  }, {
    "key": "cs:cenik",
    "href": "/cenik"
  }, {
    "key": "cs:chci-aplikaci",
    "href": "/chci-aplikaci"
  }, {
    "key": "cs:css-program",
    "href": "/css-program"
  }, {
    "key": "cs:dokumenty/index",
    "href": "/dokumenty"
  }, {
    "key": "cs:dokumenty/generated/informacni-memorandum",
    "href": "/dokumenty/generated/informacni-memorandum"
  }, {
    "key": "cs:dokumenty/generated/post",
    "href": "/dokumenty/generated/[post]"
  }, {
    "key": "cs:doporucte-nas",
    "href": "/doporucte-nas"
  }, {
    "key": "cs:dobirka",
    "href": "/dobirka"
  }, {
    "key": "cs:dotaznik",
    "href": "/dotaznik"
  }, {
    "key": "cs:informacni-memorandum",
    "href": "/informacni-memorandum"
  }, {
    "key": "cs:investuj-pri-nakupovani",
    "href": "/investuj-pri-nakupovani"
  }, {
    "key": "cs:jak-zaplatit",
    "href": "/jak-zaplatit"
  }, {
    "key": "cs:kariera/index",
    "href": "/kariera"
  }, {
    "key": "cs:kariera/volne-pozice",
    "href": "/kariera/volne-pozice"
  }, {
    "key": "cs:kariera/detail",
    "href": "/kariera/[job]"
  }, {
    "key": "cs:caste-dotazy/index",
    "href": "/caste-dotazy"
  }, {
    "key": "cs:caste-dotazy/category",
    "href": "/caste-dotazy/[category]"
  }, {
    "key": "cs:caste-dotazy/question",
    "href": "/caste-dotazy/[category]/[question]"
  }, {
    "key": "cs:karta",
    "href": "/karta"
  }, {
    "key": "cs:kde-nakupovat",
    "href": "/kde-nakupovat"
  }, {
    "key": "cs:kontakty",
    "href": "/kontakty"
  }, {
    "key": "cs:kontokorent",
    "href": "/kontokorent"
  }, {
    "key": "cs:kreditni-karta",
    "href": "/kreditni-karta"
  }, {
    "key": "cs:kurzovni-listek",
    "href": "/kurzovni-listek"
  }, {
    "key": "cs:mallpay",
    "href": "/mallpay"
  }, {
    "key": "cs:mobilni-aplikace",
    "href": "/mobilni-aplikace"
  }, {
    "key": "cs:nase-produkty",
    "href": "/nase-produkty"
  }, {
    "key": "cs:nakup-na-splatky",
    "href": "/nakup-na-splatky"
  }, {
    "key": "cs:nakup-na-tretinu",
    "href": "/nakup-na-tretinu"
  }, {
    "key": "cs:nakupujte-s-rozumem",
    "href": "/nakupujte-s-rozumem"
  }, {
    "key": "cs:napsali-o-nas",
    "href": "/napsali-o-nas"
  }, {
    "key": "cs:nastaveni-soukromi",
    "href": "/nastaveni-soukromi"
  }, {
    "key": "cs:o-skippay",
    "href": "/o-skippay"
  }, {
    "key": "cs:odhlaseni-novinek/token",
    "href": "/odhlaseni-novinek/[token]"
  }, {
    "key": "cs:odlozena-platba",
    "href": "/odlozena-platba"
  }, {
    "key": "cs:odlozeni-splatnosti",
    "href": "/odlozeni-splatnosti"
  }, {
    "key": "cs:odmeny",
    "href": "/odmeny"
  }, {
    "key": "cs:openapi",
    "href": "/openapi"
  }, {
    "key": "cs:partneri",
    "href": "/partneri"
  }, {
    "key": "cs:ostatni-dokumenty",
    "href": "/ostatni-dokumenty"
  }, {
    "key": "cs:platba-kartou",
    "href": "/platba-kartou"
  }, {
    "key": "cs:platba-online",
    "href": "/platba-online"
  }, {
    "key": "cs:platba-skip-pay",
    "href": "/platba-skip-pay"
  }, {
    "key": "cs:platebni-brana",
    "href": "/platebni-brana"
  }, {
    "key": "cs:pojisteni/index",
    "href": "/pojisteni"
  }, {
    "key": "cs:pojisteni/pojistne-podminky",
    "href": "/pojisteni/pojistne-podminky"
  }, {
    "key": "cs:pojisteni-ke-karte",
    "href": "/pojisteni-ke-karte"
  }, {
    "key": "cs:prevod-penez",
    "href": "/prevod-penez"
  }, {
    "key": "cs:pro-eshop",
    "href": "/pro-eshop"
  }, {
    "key": "cs:pro-novinare",
    "href": "/pro-novinare"
  }, {
    "key": "cs:pro-vyvojare",
    "href": "/pro-vyvojare"
  }, {
    "key": "cs:prodlouzena-zaruka",
    "href": "/prodlouzena-zaruka"
  }, {
    "key": "cs:pujcka",
    "href": "/pujcka"
  }, {
    "key": "cs:pujcky",
    "href": "/pujcky"
  }, {
    "key": "cs:recenze-klientu",
    "href": "/recenze-klientu"
  }, {
    "key": "cs:balicek-maxi",
    "href": "/balicek-maxi"
  }, {
    "key": "cs:slevy/index",
    "href": "/slevy"
  }, {
    "key": "cs:slevy/category",
    "href": "/slevy/kategorie/[category]"
  }, {
    "key": "cs:slevy/eshop",
    "href": "/slevy/[eshop]"
  }, {
    "key": "cs:splatky",
    "href": "/splatky"
  }, {
    "key": "cs:srovnavac-produktu/index",
    "href": "/srovnavac-produktu"
  }, {
    "key": "cs:srovnavac-produktu/vyhledavani",
    "href": "/srovnavac-produktu/vyhledavani"
  }, {
    "key": "cs:srovnavac-produktu/category",
    "href": "/srovnavac-produktu/[category]"
  }, {
    "key": "cs:srovnavac-produktu/subcategoryLevelOne",
    "href": "/srovnavac-produktu/[category]/[subcategoryLevelOne]"
  }, {
    "key": "cs:srovnavac-produktu/subcategoryLevelTwo",
    "href": "/srovnavac-produktu/[category]/[subcategoryLevelOne]/[subcategoryLevelTwo]"
  }, {
    "key": "cs:srovnavac-produktu/subcategoryLevelThree",
    "href": "/srovnavac-produktu/[category]/[subcategoryLevelOne]/[subcategoryLevelTwo]/[subcategoryLevelThree]"
  }, {
    "key": "cs:srovnavac-produktu/subcategoryLevelFour",
    "href": "/srovnavac-produktu/[category]/[subcategoryLevelOne]/[subcategoryLevelTwo]/[subcategoryLevelThree]/[subcategoryLevelFour]"
  }, {
    "key": "cs:srovnavac-produktu/subcategoryLevelFive",
    "href": "/srovnavac-produktu/[category]/[subcategoryLevelOne]/[subcategoryLevelTwo]/[subcategoryLevelThree]/[subcategoryLevelFour]/[subcategoryLevelFive]"
  }, {
    "key": "cs:srovnavac-produktu/subcategoryLevelSix",
    "href": "/srovnavac-produktu/[category]/[subcategoryLevelOne]/[subcategoryLevelTwo]/[subcategoryLevelThree]/[subcategoryLevelFour]/[subcategoryLevelFive]/[subcategoryLevelSix]"
  }, {
    "key": "cs:sprava-osobnich-udaju/index",
    "href": "/sprava-osobnich-udaju"
  }, {
    "key": "cs:sprava-osobnich-udaju/token",
    "href": "/sprava-osobnich-udaju/[token]"
  }, {
    "key": "cs:tiskove-zpravy/index",
    "href": "/tiskove-zpravy"
  }, {
    "key": "cs:tiskove-zpravy/pressRelease",
    "href": "/tiskove-zpravy/[pressRelease]"
  }, {
    "key": "cs:uvitaci-video",
    "href": "/uvitaci-video"
  }, {
    "key": "cs:vseobecne-obchodni-podminky",
    "href": "/vseobecne-obchodni-podminky"
  }, {
    "key": "cs:whistleblowing",
    "href": "/whistleblowing"
  }, {
    "key": "cs:zaplatim-po-vanocich",
    "href": "/zaplatim-po-vanocich"
  }, {
    "key": "cs:my-to-platime",
    "href": "/my-to-platime"
  }, {
    "key": "cs:zruseni-skip-pay",
    "href": "/zruseni-skip-pay"
  }, {
    "key": "cs:vraceni-preplatku/index",
    "href": "/vraceni-preplatku"
  }, {
    "key": "cs:vraceni-preplatku/token",
    "href": "/vraceni-preplatku/[token]"
  }, {
    "key": "cs:hlaseni-skody",
    "href": "/hlaseni-skody"
  }, {
    "key": "cs:cenik",
    "href": "/cenik"
  }, {
    "key": "sk:cenik",
    "href": "/sk/cennik"
  }, {
    "key": "hu:cenik",
    "href": "/hu/pricing"
  }],
  meta: [{
    "key": "cs:cenik",
    "data": {}
  }, {
    "key": "sk:cenik",
    "data": {}
  }, {
    "key": "hu:cenik",
    "data": {}
  }]
});

// @ts-ignore
export const getStaticProps: GetStaticProps = async context => __root.getStaticProps({
  ...context,
  __locale: 'cs'
});
export default CenikPage;